/* eslint-disable import/extensions */
import { Button, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { MdEdit } from 'react-icons/md';
import { data } from './mock.js';

import { SAHeader } from '../../../../components/singleComponents/headers/SuperAdminHeader/SAHeader';
import {
  BoxButtonsStyled,
  ContainerButtonsStyled,
  ContainerTextStyled,
  EditIconStyled,
  RootStyled,
  TextStyled,
} from './index.styles';

export function Privacy() {
  const [inputTerm, setInputTerm] = useState('');
  const [showInput, setShowInput] = useState(false);

  useEffect(() => {
    setInputTerm(data.termsOfUse.privacy);
  }, []);

  return (
    <RootStyled>
      <SAHeader iconHome iconSettings />
      <Typography variant="h3">Alterar políticas de privacidade</Typography>
      <ContainerTextStyled style={{ display: showInput && 'none' }}>
        <div style={{ display: 'flex' }}>
          <Typography variant="body1">{data.termsOfUse.privacy}</Typography>
          <EditIconStyled>
            <IconButton
              style={{ backgroundColor: '#33364D' }}
              onClick={() => setShowInput(!showInput)}
              size="large"
            >
              <MdEdit color="#e2e2e2" />
            </IconButton>
          </EditIconStyled>
        </div>
      </ContainerTextStyled>
      <div style={{ marginTop: 32 }}>
        <TextStyled
          label="Alterar termos de uso"
          color="secondary"
          variant="outlined"
          value={inputTerm}
          onChange={(e) => setInputTerm(e.target.value)}
          style={{
            display: !showInput && 'none',
          }}
          slotProps={{
            inputLabel: { shrink: true },
          }}
          focused
        />
        <ContainerButtonsStyled
          style={{ display: showInput ? 'flex' : 'none' }}
        >
          <div />
          <BoxButtonsStyled>
            <Typography variant="h4" onClick={() => setShowInput(!showInput)}>
              Cancelar
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => console.log(inputTerm)}
            >
              Alterar política de privacidade
            </Button>
          </BoxButtonsStyled>
        </ContainerButtonsStyled>
      </div>
    </RootStyled>
  );
}
